import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraSurface } from '../ensigns/surface';
/** Framed AI/message composer; input behavior remains controlled by the app. */ export function SpecraComposerSurface({ children, className, controls, ...props }) {
    return /*#__PURE__*/ _jsxs(SpecraSurface, {
        className: cn('p-2', className),
        tone: "card",
        ...props,
        children: [
            children,
            controls ? /*#__PURE__*/ _jsx("div", {
                className: "mt-2 flex items-center gap-1",
                children: controls
            }) : null
        ]
    });
}
